module.exports = __webpack_public_path__ + "static/img/thumbnail-medium.fadf19e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/thumbnail-medium.jpg
// module id = QxoI
// module chunks = 1